// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d04038d","732":"ed509af6","977":"2df9904d"}[chunkId] + ".chunk.js";
};